var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_UserManagement",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_User_Management",
    "data-name": "Icon_User Management",
    d: "M10,0a9.778,9.778,0,0,1,3.884.792,9.824,9.824,0,0,1,5.324,5.324,9.921,9.921,0,0,1,.006,7.757,9.968,9.968,0,0,1-2.126,3.192A10.119,10.119,0,0,1,13.9,19.2a9.939,9.939,0,0,1-7.79.006,9.924,9.924,0,0,1-3.186-2.137A10.188,10.188,0,0,1,.793,13.878a9.9,9.9,0,0,1,0-7.762A9.824,9.824,0,0,1,6.116.792,9.778,9.778,0,0,1,10,0Zm6.908,15.078A8.438,8.438,0,0,0,18.571,10a8.343,8.343,0,0,0-.681-3.326,8.471,8.471,0,0,0-4.565-4.565,8.468,8.468,0,0,0-6.652,0A8.471,8.471,0,0,0,2.108,6.674,8.338,8.338,0,0,0,1.428,10a8.44,8.44,0,0,0,1.663,5.078q.737-3.649,3.415-3.649A4.825,4.825,0,0,0,10,12.857a4.825,4.825,0,0,0,3.493-1.428q2.678,0,3.415,3.649ZM14.286,7.857a4.129,4.129,0,0,0-1.256-3.03A4.129,4.129,0,0,0,10,3.572,4.129,4.129,0,0,0,6.97,4.827a4.129,4.129,0,0,0-1.256,3.03,4.129,4.129,0,0,0,1.256,3.03A4.129,4.129,0,0,0,10,12.143a4.129,4.129,0,0,0,3.03-1.256,4.129,4.129,0,0,0,1.256-3.03Z",
    fill: "#4f4f4f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserManagement);
export default __webpack_public_path__ + "static/media/Icon_UserManagement.66f8e6e5731d446ae6c0eb44125ea2ac.svg";
export { ForwardRef as ReactComponent };